import request from '@/utils/request'

const goods = {
  name: 'goods',
  state: {
    isGoodsDetailLoading: false,
    goodsDetailData: {},
    goodsId: 0
  },

  mutations: {
    SET_IS_MODULES_GOODS_DETAIL_LOADING: (state, data) => {
      state.isGoodsDetailLoading = data
    },
    SET_MODULES_GOODS_DETAIL_DATA: (state, data) => {
      state.goodsDetailData = data
    },
    SET_MODULES_GOODS_ID: (state, data) => {
      state.goodsId = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryGoodsDetailData({ commit }, id) {
      commit('SET_IS_MODULES_GOODS_DETAIL_LOADING', true)
      commit('SET_MODULES_GOODS_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/goods/goodsDetails',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_GOODS_DETAIL_LOADING', false)
          commit('SET_MODULES_GOODS_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_GOODS_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetGoodsDetailData({ commit }) {
      commit('SET_MODULES_GOODS_DETAIL_DATA', {})
    },
    //  重置账号新增页面数据
    setGoodsId({ commit }, data) {
      commit('SET_MODULES_GOODS_ID', data)
    }
  }
}

export default goods
